import { render, staticRenderFns } from "./PaySuccess.vue?vue&type=template&id=2d93580f&scoped=true"
import script from "./PaySuccess.vue?vue&type=script&lang=js"
export * from "./PaySuccess.vue?vue&type=script&lang=js"
import style0 from "./PaySuccess.vue?vue&type=style&index=0&id=2d93580f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d93580f",
  null
  
)

export default component.exports